import React, {Component} from 'react';
import Modelizer from 'ryvendor/Ry/Core/Modelizer';
import moment from "moment/moment";
import $ from "jquery";
import numeral from "numeral";
import './dashboard.scss';
import turndown from '../../medias/images/turn-right.png';
import swal from 'sweetalert2';
import { Doughnut } from "react-chartjs-2";
import axios from 'axios';
import trans, {DATES} from '../../gha/translations';

class Dashboard extends Component
{
    
    constructor(props) {
        super(props)
        this.state = {}
        this.endpoint = '/'
        this.state.date = moment().format('YYYY-MM-DD')
        this.state.datefilter = this.models('props.data.filter.departure_datefrom') ? 'date' : 'month'
        this.state.filter = {
            departure_datefrom : this.models('props.data.filter.departure_datefrom', moment()),
            departure_dateto : this.models('props.data.filter.departure_dateto', moment()),
            airline_id : '',
            month : this.models('props.data.filter.month', ''),
            year : this.models('props.data.filter.year', '')
        }
        this.state.datebydate = false
        this.xhrdata = {...this.state.filter}
        this.xhrdata.departure_datefrom = moment(this.xhrdata.departure_datefrom).format('YYYY-MM-DD')
        this.xhrdata.departure_dateto = moment(this.xhrdata.departure_dateto).format('YYYY-MM-DD')
        let criterias = this.models('props.data.filter', {})
        this.data = {
            json : true,
            s : Array.isArray(criterias) ? {
                month : moment().format('MM')
            } : criterias 
        }
        this.state.exportingdata = 0
        this.state.currentmonth = this.props.data.currentmonth
        this.state.selectedyear = this.props.data.selectedyear
        this.state.selectedmonth = this.props.data.selectedmonth
        this.searchData = this.searchData.bind(this)
        this.handleDateChecked = this.handleDateChecked.bind(this)
        this.exportData = this.exportData.bind(this)
        this.handleMonthChange = this.handleMonthChange.bind(this)
        this.handleYearChange = this.handleYearChange.bind(this)
    }

    handleMonthChange(event) {
        const value = event.target.value
        this.setState(state=>{
            state.filter.month = value
            return state
        })
    }

    handleYearChange(event) {
        const value = event.target.value
        this.setState(state=>{
            state.filter.year = value
            return state
        })
    }

    componentDidMount() {
        console.log('Dashboard')
        console.log(this.props.data)
        const opts = {
            language : 'fr',
            autoclose : true
        }
        const dp = $(this.refs.datepicker).datepicker(opts)
        const dp_to = $(this.refs.datepicker_to).datepicker(opts)
        dp.on("changeDate", ()=>{
            if(this.state.datefilter!='date')
                return

            const date = moment(dp.datepicker('getDate')).format('YYYY-MM-DD')
            this.setState(state=>{
                state.filter.departure_datefrom = date
                state.date = date
                return state
            })
            this.data.s.departure_datefrom = date
        });
        dp_to.on("changeDate", ()=>{
            if(this.state.datefilter!='date')
                return

            const date = moment(dp_to.datepicker('getDate')).format('YYYY-MM-DD')
            if(this.pxhr)
                this.pxhr.abort()
            this.setState(state=>{
                state.filter.departure_dateto = date
                return state
            })
            this.data.s.departure_dateto = date
        });
    }


    handleDateChecked(event) {
        const value = event.target.value
        let ischecked = false
        if(event.target.checked) {
            ischecked = true
        }
        this.setState(state=>{
            state.datebydate = ischecked
            state.datefilter = value
            return state
        })
    }

    searchData() {
        if(this.pxhr)
            this.pxhr.abort()
        this.urls = []
        this.data.s.airline_id = this.refs.airline.value
        this.data.s.departure_location = this.refs.origin.value
        this.data.s.arrival_location = this.refs.destination.value
        
        if(this.state.datebydate == false)
        {
            this.data.s.month = this.refs.month.value
            this.data.s.year = this.refs.year.value
            delete this.data.s.departure_datefrom
            delete this.data.s.departure_dateto
        } else {
            this.data.s.departure_datefrom = moment(this.state.filter.departure_datefrom).format('YYYY-MM-DD')
            this.data.s.departure_dateto = moment(this.state.filter.departure_dateto).format('YYYY-MM-DD')
            delete this.data.s.month
            delete this.data.s.year
        }

        if(this.request) {
            this.request.abort()
        }
        this.request = $.ajax({
            isPagination : true,
            url : this.endpoint,
            data : this.data,
            success : response=>{
                this.setState(state=>{
                    state.data = response.data
                    state.selectedmonth = response.selectedmonth
                    state.selectedyear = response.selectedyear
                    state.currentmonth = response.currentmonth
                    return state
                })
                window.setTimeout(this.progress, 100)
            }
        })
    }

    async exportData()
    {
        this.setState(state=>{
            state.exportingdata = 1
            return state
        })
        let filename = "STATS GHA "+moment().format("YYYYMMDDHHmmss")+".xlsx";
        let dataids = []
        for (let i = 0; i < this.state.data.length; i++)
        {
            let uldid = this.state.data[i].id
            dataids.push(uldid)
        }
        await axios.post('/exportdatas', {data: dataids}, { responseType: 'blob' })
        .then((response) => {
            console.log(response);
            let blob = new Blob([response.data], {
                type: 'application/vnd.ms-excel'
            })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename
            this.setState(state=>{
                state.exportingdata = 0
                return state
            })
            link.click()
        })
        .catch((error) => console.log(error));
    }


    table() {
        return (
            <table className="table table-bordered table-hover table-striped table-liste mail-manifest" cellSpacing="0">
                <thead>
                    <tr>
                        <th style={{width: '120px'}}>{trans('Nº de vol')}</th>
                        <th style={{width: '120px'}}>{trans('Date du vol')}</th>
                        <th style={{width: '250px'}}>{trans('ULD')}</th>
                        <th>{trans('Pcs')}</th>
                        <th style={{width: '120px'}}>{trans('Poids (Kg)')}</th>
                        <th style={{width: '98px'}}>{trans('Destination')}</th>
                    </tr>
                </thead>

                <tbody>
                    {this.state.data
                        ? this.state.data.map((flight, i) => {
                            if (flight.receptacles.length == 0) return null
                            return (
                                <tr key={`tr-${i}`}>
                                    <td>{flight.conveyence.reference}</td>
                                    <td>{moment.utc(flight.conveyence.departure_datetime_lt).local().format('DD/MM/YYYY')}</td>
                                    <td className="text-blue text-center">{flight.uld.code}</td>
                                    <td>{flight.nsetup.nreceptacles}</td>
                                    <td>{numeral(parseFloat(flight.nsetup.wreceptacles)).format('0,0.0')}</td>
                                    <td>{flight.conveyence.arrival_location.iata}</td>
                                </tr>
                            );
                        })
                        : null}
                </tbody>

                <tfoot></tfoot>
            </table>
        );
    }


    render() {
        return (
            <div className="cardit-container vol-liste col-md-12">
                <div className="row clearfix align-items-stretch position-relative vol-container">
                    <div className="col-12">
                        <div className="topContainer mb-2 d-flex justify-content-between align-items-center">
                            <div className="col-md-12 mt-2"><div className="align-items-baseline row">
                                    <div className="col-md-3">
                                        <div className="align-items-baseline d-flex form-group ml-2">
                                            <label className="control-label col-md-3 text-right">Airline</label>
                                            <select className="form-control col-md-9" value={this.state.filter.airline_id} ref="airline">
                                                <option value="">{trans('Tous')}</option>
                                                {this.props.data.airlines.map(airline=><option key={`select-airline-${airline.id}`} value={airline.id}>{airline.name}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="align-items-baseline d-flex form-group ml-2">
                                            <label className="control-label col-md-3 text-center p-0">{trans('Origine')}</label>
                                            <select className="form-control col-md-9" value={this.state.filter.departure_location} ref="origin">
                                                <option value="">{trans('Tous')}</option>
                                                {this.props.data.select_origins.map(departure_location=><option key={`select-handover-origin-location-${departure_location.iata}`} value={departure_location.id}>{departure_location.iata}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className={`col-md-2`}>
                                        <div className="align-items-baseline d-flex form-group ml-2">
                                            <label className="control-label col-md-3 text-center p-0 mr-3">Dest.</label>
                                            <select className="form-control col-md-9" value={this.state.filter.arrival_location} ref="destination">
                                                <option value="">{trans('Tous')}</option>
                                                {this.props.data.select_destinations.map(arrival_location=><option key={`select-handover-destination-location-${arrival_location.iata}`} value={arrival_location.id}>{arrival_location.iata}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-items-baseline row">
                                    <div className="col-md-2">               
                                        <div className="align-items-baseline d-flex form-group ml-2">
                                            <select className="form-control col-md-9" value={this.state.filter.month} ref="month" onChange={this.handleMonthChange}>
                                                {this.props.data.months.map((month, index)=><option key={index} value={month} defaultValue={this.state.selectedmonth}>{moment.months(index)}</option>)}
                                            </select>
                                        </div>   
                                    </div>
                                    <div className="col-md-2">               
                                        <div className="align-items-baseline d-flex form-group ml-2">  
                                            <select className="form-control col-md-9" value={this.state.filter.year} ref="year" onChange={this.handleYearChange}>
                                                {this.props.data.years.map((year, index)=><option key={index} value={year} defaultValue={this.state.selectedyear}>{year}</option>)}
                                            </select>
                                        </div>   
                                    </div>
                                    <div className={`col-md-2`}>
                                        <div className="align-items-baseline d-flex form-group ml-2">
                                            <div className="d-flex col-md-3 p-0 mr-3">
                                                <div className="form-group m-auto">
                                                    <label className="control-label ml-3 mr-2 mb-0">{trans('ou')}</label>
                                                </div>
                                                <label className="fancy-radio m-auto custom-color-green">
                                                    <input name={`date-filter`} type="radio" value="date" checked={this.state.datefilter=='date'} onChange={this.handleDateChecked}/>
                                                    <span><i className="mr-0"></i></span>
                                                </label>
                                            </div>
                                            <div ref="datepicker" className="input-group date col-md-9 p-0">
                                                <input type="text" className="form-control" defaultValue={moment(this.state.filter.departure_datefrom).format("DD/MM/YYYY")}/>
                                                <div className="input-group-append">
                                                    <button className="btn-primary btn text-light" type="button"><i className="fa fa-calendar-alt"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="align-items-baseline d-flex form-group ml-2">
                                            <label className="control-label col-md-3 text-center p-0">{trans('au')}</label>
                                            <div ref="datepicker_to" className="input-group date col-md-9 p-0">
                                                <input type="text" className="form-control" value={moment(this.state.filter.departure_dateto).format("DD/MM/YYYY")}/>
                                                <div className="input-group-append">
                                                    <button className="btn-primary btn text-light" type="button"><i className="fa fa-calendar-alt"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="align-items-baseline d-flex form-group ml-2">
                                            <button className="btn btn-excel" onClick={this.searchData}>{trans('OK')}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card overflowhidden mt-3 container-fluid">
                            <div className="body p-4">
                                <div className="row m-3 align-items-center">
                                    <div className="col-md-3 pr-0">
                                        <button className="btn btn-excel" onClick={this.exportData}>{(this.state.exportingdata == 0) ? trans('Extract data') : <i class="fas fa-spinner fa-spin"></i>}</button>
                                    </div>
                                </div>
                                <div className="row m-0 align-items-top">
                                    <div className="col-md-12">
                                        <div className="card-bureau no-border p-0">
                                            <div className="table-responsive">
                                                {this.table()}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Modelizer(Dashboard);